import React, { useContext, useMemo } from 'react';
import { TextsContext } from '../../../context/textsContext';
import MetricCard from './MetricCard';
import style from '../../../scss/dashboard.module.scss';

const MetricsSection = () => {
    const { texts } = useContext(TextsContext);

    const cards = useMemo(() => [
        { metric: 'total', icon: 'mdi:clipboard-check-outline', title: texts?.dashboard_card_total ?? 'Total of Templates' },
        { metric: 'used', icon: 'mdi:airplane-clock', title: texts?.dashboard_card_used ?? 'Used Templates' },
        { metric: 'updated', icon: 'mdi:file-document-multiple-outline', title: texts?.dashboard_card_edited ?? 'Edited Templates' },
        { metric: 'deleted', icon: 'mdi:card-account-details-outline', title: texts?.dashboard_card_cancelled ?? 'Cancelled Templates' },
    ], [texts]);

    const comparisonText = texts?.dashboard_card_vs_last_month ?? 'vs. last month';

    return (
        <div className={`row g-4 ${style.metrics}`}>
            {cards.map((card) => (
                <div className="col-12 col-sm-6 col-xl-3" key={card.metric}>
                    <MetricCard
                        metric={card.metric}
                        icon={card.icon}
                        title={card.title}
                        comparisonText={comparisonText}
                    />
                </div>
            ))}
        </div>
    );
};

export default React.memo(MetricsSection);
